import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import '../styles/header.css';
import './LiveCourseDetail.css'


const COURSES_DATA = {
  'course-registration': {
    id: 'course-registration',
    title: 'Course Registration',
    description: 'Complete package for course registration with access to all materials and expert guidance.',
    originalPrice: '₹9999.00',
    price: '₹5100.00',
    instructor: 'Senior Education Consultant',
    duration: '4 Months',
    modules: [
      { title: 'Course Selection Strategies', duration: '45 min', videoUrl: '#' },
      { title: 'Registration Process Walkthrough', duration: '30 min', videoUrl: '#' },
      { title: 'Material Access Guide', duration: '25 min', videoUrl: '#' },
      { title: 'Maximizing Learning Outcomes', duration: '40 min', videoUrl: '#' }
    ],
    resources: [
      'Course Catalog.pdf',
      'Registration Checklist.docx',
      'Study Plan Template.xlsx'
    ],
    exercises: [
      'Create your personalized study plan',
      'Complete mock registration process',
      'Set up your learning environment'
    ],
    isLimitedOffer: true
  },
  'salesforce-ai-bootcamp': {
    id: 'salesforce-ai-bootcamp',
    title: 'Salesforce AI - APP Development Bootcamp',
    description: 'Build AI-powered Salesforce applications with Einstein AI integration and real-world projects.',
    originalPrice: '₹10000.00',
    price: '₹499.00',
    instructor: 'Salesforce AI Specialist',
    duration: '6 weeks',
    modules: [
      { title: 'Introduction to Salesforce AI', duration: '60 min', videoUrl: '#' },
      { title: 'Einstein Platform Basics', duration: '75 min', videoUrl: '#' },
      { title: 'Building AI-Powered Apps', duration: '90 min', videoUrl: '#' },
      { title: 'Real-World Implementation', duration: '120 min', videoUrl: '#' }
    ],
    resources: [
      'AI Cheat Sheet.pdf',
      'Sample AI Projects.zip',
      'Certification Guide.docx'
    ],
    exercises: [
      'Create a simple prediction model',
      'Integrate Einstein Vision',
      'Build a recommendation engine'
    ],
    isBestseller: true,
    isLimitedOffer: true
  },
  'salesforce-business-analyst': {
    id: 'salesforce-business-analyst',
    title: 'Salesforce Business Analyst',
    description: 'Master business analysis techniques specific to Salesforce implementations and configurations.',
    originalPrice: '₹50000.00',
    price: '₹45000.00',
    instructor: 'Certified Business Analyst',
    duration: '3 months',
    modules: [
      { title: 'Business Requirements Analysis', duration: '80 min', videoUrl: '#' },
      { title: 'Process Mapping Techniques', duration: '90 min', videoUrl: '#' },
      { title: 'Stakeholder Management', duration: '75 min', videoUrl: '#' },
      { title: 'Salesforce Configuration Basics', duration: '85 min', videoUrl: '#' }
    ],
    resources: [
      'BA Templates Collection.zip',
      'Requirement Gathering Techniques.pdf',
      'Case Studies.docx'
    ],
    exercises: [
      'Conduct a requirements workshop',
      'Create process flow diagrams',
      'Document user stories'
    ],
    category: ['Salesforce', 'Business Analysis']
  },
  'salesforce-lwc-developer': {
    id: 'salesforce-lwc-developer',
    title: 'Salesforce LWC Developer',
    description: 'Become proficient in Lightning Web Components development for modern Salesforce applications.',
    originalPrice: '₹25000.00',
    price: '₹19000.00',
    instructor: 'Senior LWC Developer',
    duration: '8 weeks',
    modules: [
      { title: 'LWC Fundamentals', duration: '90 min', videoUrl: '#' },
      { title: 'JavaScript for LWC', duration: '120 min', videoUrl: '#' },
      { title: 'Component Communication', duration: '95 min', videoUrl: '#' },
      { title: 'Performance Optimization', duration: '85 min', videoUrl: '#' }
    ],
    resources: [
      'LWC Best Practices.pdf',
      'Component Library.zip',
      'Debugging Guide.docx'
    ],
    exercises: [
      'Build a reusable data table',
      'Create a parent-child component set',
      'Optimize component rendering'
    ],
    category: ['Salesforce', 'Development']
  },
  'career-guidance-general': {
    id: 'career-guidance-general',
    title: 'Career Guidance On What to Choose',
    description: 'Personalized career assessment and roadmap creation to help you choose the right path.',
    originalPrice: '₹499.00',
    price: '₹299.00',
    instructor: 'Career Coach',
    duration: '30 min session',
    modules: [
      { title: 'Skills Assessment', duration: '30 min', videoUrl: '#' },
      { title: 'Industry Trends Analysis', duration: '25 min', videoUrl: '#' },
      { title: 'Roadmap Creation', duration: '35 min', videoUrl: '#' }
    ],
    resources: [
      'Career Assessment Tool.xlsx',
      'Industry Reports.pdf',
      'Sample Resumes.zip'
    ],
    exercises: [
      'Complete skills inventory',
      'Research target roles',
      'Draft career roadmap'
    ],
    isBestseller: true,
    isSession: true
  },
  'career-guidance-salesforce': {
    id: 'career-guidance-salesforce',
    title: 'Career Guidance On Salesforce',
    description: 'Specialized guidance for building a successful career in the Salesforce ecosystem.',
    originalPrice: '₹499.00',
    price: '₹299.00',
    instructor: 'Salesforce Career Advisor',
    duration: '30 min session',
    modules: [
      { title: 'Salesforce Career Paths', duration: '40 min', videoUrl: '#' },
      { title: 'Certification Roadmap', duration: '35 min', videoUrl: '#' },
      { title: 'Interview Preparation', duration: '45 min', videoUrl: '#' }
    ],
    resources: [
      'Certification Path.pdf',
      'Salary Benchmarks.docx',
      'Interview Questions.zip'
    ],
    exercises: [
      'Map your certification path',
      'Practice common interview questions',
      'Develop your elevator pitch'
    ],
    isBestseller: true,
    isSession: true,
    category: ['Salesforce', 'Career']
  },
  'salesforce-platform-developer': {
    id: 'salesforce-platform-developer',
    title: 'Salesforce Platform Developer',
    description: 'Advanced training for developers looking to master complex Salesforce implementations.',
    originalPrice: '₹49999.00',
    price: '₹44999.00',
    instructor: 'Salesforce Architect',
    duration: '4 months',
    modules: [
      { title: 'Advanced Apex Patterns', duration: '120 min', videoUrl: '#' },
      { title: 'Integration Architectures', duration: '110 min', videoUrl: '#' },
      { title: 'Security Best Practices', duration: '95 min', videoUrl: '#' },
      { title: 'Complex Business Logic', duration: '130 min', videoUrl: '#' }
    ],
    resources: [
      'Design Patterns.pdf',
      'Integration Samples.zip',
      'Security Checklist.docx'
    ],
    exercises: [
      'Implement a trigger framework',
      'Build a REST API integration',
      'Create a complex validation system'
    ],
    category: ['Salesforce', 'Development']
  },
  'advanced-apex-developer': {
    id: 'advanced-apex-developer',
    title: 'Advanced Apex Developer ',
    description: 'Comprehensive course on advanced Apex programming techniques and best practices.',
    originalPrice: '₹24999.00',
    price: '₹22999.00',
    instructor: 'Certified Platform Developer',
    duration: '3 months + projects',
    modules: [
      { title: 'Async Apex  ', duration: '90 min', videoUrl: '#' },
      { title: 'Integration Techniques', duration: '85 min', videoUrl: '#' },
      { title: 'Salesforce APIs', duration: '95 min', videoUrl: '#' },
      { title: 'Testing & Debugging', duration: '80 min', videoUrl: '#' }
    ],
    resources: [
      'PD1 Study Guide.pdf',
      'Practice Exams.zip',
      'Code Samples.docx'
    ],
    exercises: [
      'Write test classes',
      'Create Visualforce pages',
      'Work with REST APIs'
    ],
    isBestseller: true,
    category: ['Salesforce', 'Certification']
  },
  'salesforce-admin-bootcamp': {
    id: 'salesforce-admin-bootcamp',
    title: 'Salesforce Admin Bootcamp',
    description: 'Intensive training covering all essential Salesforce administration skills.',
    originalPrice: '₹35000.00',
    price: '₹29999.00',
    instructor: 'Senior Salesforce Admin',
    duration: '6 weeks',
    modules: [
      { title: 'Administration Essentials', duration: '100 min', videoUrl: '#' },
      { title: 'Security & Access Control', duration: '95 min', videoUrl: '#' },
      { title: 'Data Management', duration: '85 min', videoUrl: '#' },
      { title: 'Automation Basics', duration: '90 min', videoUrl: '#' }
    ],
    resources: [
      'Admin Handbook.pdf',
      'Data Loader Guide.docx',
      'Automation Templates.zip'
    ],
    exercises: [
      'Configure profiles and permission sets',
      'Perform data import/export',
      'Create workflow rules'
    ],
    category: ['Salesforce', 'Administration']
  },
  'salesforce-cpq-specialist': {
    id: 'salesforce-cpq-specialist',
    title: 'Salesforce CPQ Specialist',
    description: 'Specialized training for implementing Configure, Price, Quote solutions in Salesforce.',
    originalPrice: '₹60000.00',
    price: '₹55000.00',
    instructor: 'CPQ Architect',
    duration: '2 months',
    modules: [
      { title: 'CPQ Fundamentals', duration: '110 min', videoUrl: '#' },
      { title: 'Product Rules', duration: '105 min', videoUrl: '#' },
      { title: 'Pricing Methodologies', duration: '115 min', videoUrl: '#' },
      { title: 'Quote Templates', duration: '95 min', videoUrl: '#' }
    ],
    resources: [
      'CPQ Implementation Guide.pdf',
      'Price Rule Examples.zip',
      'Quote Template Samples.docx'
    ],
    exercises: [
      'Configure product bundles',
      'Create discount schedules',
      'Design quote templates'
    ],
    category: ['Salesforce', 'CPQ']
  }
};

const calculateDiscountPercentage = (originalPrice, salePrice) => {
    const original = parseFloat(originalPrice.replace(/[^0-9.]/g, '')) || 0;
    const sale = parseFloat(salePrice.replace(/[^0-9.]/g, '')) || 0;
    
    if (original <= 0 || sale >= original) return 0;
    
    return Math.round(((original - sale) / original) * 100);
  };

const CourseDetail = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
  
  const course = COURSES_DATA[courseId];

  if (!course) {
    return (
      <div className="course-detail-page">
        {/* <Header /> */}
        <div className="course-not-found">
          <h2>Course not found</h2>
          <button onClick={() => navigate('/courses')} className="back-button">
            Back to Courses
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="course-detail-page">
      {/* <Header /> */}
      
      <div className="course-header">
        <div className="course-badges">
          {course.isBestseller && <span className="badge bestseller">Bestseller</span>}
          {course.isLimitedOffer && <span className="badge limited-offer">Limited Offer</span>}
        </div>
        <h1>{course.title}</h1>
        <p className="course-description">{course.description}</p>
        <p className="course-meta">
          <span className="instructor">Instructor: {course.instructor}</span>
          <span className="duration">Duration: {course.duration}</span>
        </p>
        <div className="course-pricing">
          {course.originalPrice && (
            <span className="original-price">{course.originalPrice}</span>
          )}
          <span className="current-price">{course.price}</span>
          {course.originalPrice && (
  <span className="discount">
    {calculateDiscountPercentage(course.originalPrice, course.price)}% OFF
  </span>
)}
        </div>
        {/* <button className="enroll-button">
          {course.isSession ? 'Book Session' : 'Enroll Now'}
        </button> */}
        <button onClick={() => navigate('/enroll')} className="enroll-button">
            {course.isSession ? 'Book This Session' : 'Enroll in This Course'}
        </button>
    
        
      </div>

      <div className="course-content">
        <section className="course-modules">
          <h2>Course Curriculum</h2>
          <ul>
            {course.modules.map((module, index) => (
              <li key={index}>
                <div className="module-header">
                  <span className="module-number">{index + 1}</span>
                  <h3>{module.title}</h3>
                  <span className="module-duration">{module.duration}</span>
                </div>
                <div className="module-progress">
                  <div className="module-progress-bar" style={{ width: '0%' }}></div>
                </div>
              </li>
            ))}
          </ul>
        </section>

        <div className="course-sidebar">
          <section className="course-resources">
            <h2>Resources</h2>
            <ul>
              {course.resources.map((resource, index) => (
                <li key={index}>
                  <a href="#" className="resource-link">
                    <span className="resource-icon">📄</span>
                    {resource}
                  </a>
                </li>
              ))}
            </ul>
          </section>

          <section className="course-exercises">
            <h2>Hands-on Exercises</h2>
            <ol>
              {course.exercises.map((exercise, index) => (
                <li key={index}>
                  <span className="exercise-number">{index + 1}.</span>
                  {exercise}
                </li>
              ))}
            </ol>
          </section>

          {course.category && (
            <section className="course-categories">
              <h2>Categories</h2>
              <div className="category-tags">
                {course.category.map((cat, index) => (
                  <span key={index} className="category-tag">{cat}</span>
                ))}
              </div>
            </section>
          )}
        </div>
      </div>

      <div className="course-cta">
      <button onClick={() => navigate('/enroll')} className="enroll-button">
            {course.isSession ? 'Book This Session' : 'Enroll in This Course'}
        </button>
        <button onClick={() => navigate('/courses')} className="back-to-courses">
          Back to All Courses
        </button>
      </div>

      <footer className="page-footer">
        <p>© {new Date().getFullYear()} CodeXLNC. All rights reserved.</p>
      </footer>
    </div>
    );
};

export default CourseDetail;